var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-loading-button',{attrs:{"href":_vm.url,"loading":_vm.isLoading,"button-class":"green button-green create-new-button"},on:{"click":_vm.createNewCampaign}},[_vm._v(" Create New Campaign ")])
}
var staticRenderFns = []

export { render, staticRenderFns }